// zh-TW.js
import elementLocale from 'element-ui/lib/locale/lang/zh-TW' // 需要先安装或自定义

export default {
  ...elementLocale,
  menu: {
    home: '首頁',
    product: '產品介紹',
    news: '新聞與資源',
    about: '關於我們',
    contact: '聯絡我們',
    case: '产品案例'
  },
  hero: {
    title: "廣納智慧創新 豐盈永續未來",
    subtitle: "加速實現淨零碳排，為各行業提供創新智慧解決方案"
  }
}